import { css } from "@emotion/react"
import { ControlButton, controlButtonStyle } from "./ControlButton"
import { Scrubber } from "./Scrubber"
import { formatDuration, formatDatetimeDuration } from "./utils"
import type { PlayerRenderProps } from "./types"

const BUTTON_SIZE = 48
const ICON_SIZE = 32

const overlayButtonStyle = controlButtonStyle({
  size: BUTTON_SIZE,
  iconSize: ICON_SIZE,
  iconColor: "var(--color-static-gray100)",
})

export function OverlayLayout({
  isPlaying,
  currentTime,
  duration,
  showSkipButtons,
  togglePlayPause,
  handleSkipBack,
  handleSkipForward,
  handleProgressInputChange,
  handleProgressKeyDown,
}: PlayerRenderProps) {
  return (
    <div
      className="p-a l-0 r-0 b-0 d-f jc-sb ai-c fd-r p-2 g-1"
      css={styles.wrapper}
    >
      {showSkipButtons && (
        <div css={styles.controlsCell}>
          <ControlButton
            icon="skipBack"
            label="Skip back 15 seconds"
            onClick={handleSkipBack}
            buttonStyle={overlayButtonStyle}
          />
        </div>
      )}
      <div css={styles.controlsCell}>
        <ControlButton
          icon={isPlaying ? "pause" : "play"}
          label={isPlaying ? "Pause" : "Play"}
          onClick={togglePlayPause}
          buttonStyle={overlayButtonStyle}
        />
      </div>
      {showSkipButtons && (
        <div css={styles.controlsCell}>
          <ControlButton
            icon="skipForward"
            label="Skip forward 30 seconds"
            onClick={handleSkipForward}
            buttonStyle={overlayButtonStyle}
          />
        </div>
      )}
      <Scrubber
        currentTime={currentTime}
        duration={duration}
        onChange={handleProgressInputChange}
        onKeyDown={handleProgressKeyDown}
      >
        <time
          css={[styles.time, styles.timeAbsLeft]}
          dateTime={formatDatetimeDuration(currentTime)}
          className="fs-4"
        >
          {currentTime ? formatDuration(currentTime) : "0:00"}
        </time>
        <time
          css={[styles.time, styles.timeAbsRight]}
          dateTime={formatDatetimeDuration(duration)}
          className="fs-4"
        >
          {formatDuration(duration)}
        </time>
      </Scrubber>
    </div>
  )
}

const styles = {
  wrapper: css`
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
  `,
  controlsCell: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  `,
  time: css`
    align-self: flex-end;
    color: var(--color-static-gray100);
  `,
  timeAbsLeft: css`
    position: absolute;
    bottom: -24px;
    left: 0;
  `,
  timeAbsRight: css`
    position: absolute;
    bottom: -24px;
    right: 0;
  `,
}
